import { useSyncExternalStore } from "react";
import { useTranslation as useTranslationOriginal } from "react-i18next";
import { localization } from "./localizationManager";
export const useTranslation = () => {
    const { t, i18n } = useTranslationOriginal();
    return { t, i18n };
};
export const useLanguage = () => {
    useTranslationOriginal();
    return {
        currentLanguage: localization.getCurrentLanguage(),
        setCurrentLanguage: localization.setCurrentLanguage,
        availableLanguages: localization.getSupportedLanguages(),
    };
};
export const useLocalization = () => {
    const isInitialized = useSyncExternalStore(localization.subscribe, () => localization.isInitialized);
    return { isInitialized };
};
